"use client";
import { useEffect } from "react";
import { resolveConsentDecision, setTrustedConsentOrigin } from "./consent";

export const TrustArcClient = ({
  trustArcOrigin,
}: {
  trustArcOrigin: string;
}) => {
  useEffect(() => {
    setTrustedConsentOrigin(trustArcOrigin);

    resolveConsentDecision().catch((error: unknown) => {
      console.error("Failed to resolve TrustArc consent decision", error);
    });
  }, [trustArcOrigin]);

  return null;
};
